var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('div',{staticClass:"c-app-menu"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'demo' }}},[_vm._v("Demo")])],1),_vm._v(" "),_c('fade',[_c('router-view',{key:_vm.routerKey})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1804d458","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = null
// module chunks = 